<div class="login-lang-switcher">
    <app-language-selector />
</div>

@if (this.showConfirmEmail || this.showForm) {
<tec-auth-layout
    img="images/tecalis-lg.svg"
    [imgTitle]="'AUTH.IMG_TITLE' | translate"
    [title]="'AUTH.TITLE' | translate"
>
    <ng-container body>
        @if (this.showConfirmEmail) {
            <tec-alert status="default" [msg]="'AUTH.CONFIRM_EMAIL_SENT' | translate" hiddenCloseButton />
        }

        @if (this.showForm) {
            @if (alertMsg) {
                <tec-alert status="error" [msg]="alertMsg" (closeAlert)="alertMsg = ''" />
            }

            <ng-container [formGroup]="form">
                <tec-form-group
                    [errorMsg]="reactiveFormsService.hasError(form.get('email'), 'required') ? ('ERRORS.REQUIRED' | translate) : ''"
                >
                    <tec-input
                        formControlName="email"
                        [placeholder]="'AUTH.EMAIL_PLACEHOLDER' | translate"
                        [hasError]="reactiveFormsService.hasError(form.get('email'))"
                    />
                </tec-form-group>
                <tec-form-group
                    [errorMsg]="reactiveFormsService.hasError(form.get('password'), 'required') ? ('ERRORS.REQUIRED' | translate) : ''"
                >
                    <tec-input
                        formControlName="password"
                        [placeholder]="'AUTH.PASSWORD_PLACEHOLDER' | translate"
                        type="password"
                        [hasError]="reactiveFormsService.hasError(form.get('password'))"
                    />
                </tec-form-group>
                <tec-button size="lg" [label]="'AUTH.SUBMIT' | translate" (clickEvent)="login()"></tec-button>
            </ng-container>
        }
    </ng-container>
</tec-auth-layout>
}
